import React from "react";
import Comments from "./Disqus";
import { Helmet } from "react-helmet";
import { Route, Switch } from "react-router-dom";
import { Link as RouterLink, BrowserRouter as Router } from "react-router-dom";

import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Dashboard from "@material-ui/icons/Dashboard";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import VideogameAsset from "@material-ui/icons/VideogameAsset";
import Memory from "@material-ui/icons/Memory";
import Mouse from "@material-ui/icons/Mouse";
import Headset from "@material-ui/icons/Headset";
import CellWifi from "@material-ui/icons/CellWifi";
import Toys from "@material-ui/icons/Toys";
import Motorcycle from "@material-ui/icons/Motorcycle";
import DeveloperBoard from "@material-ui/icons/DeveloperBoard";
import Usb from "@material-ui/icons/Usb";
import HomeIcon from "@material-ui/icons/Home";
import Build from "@material-ui/icons/Build";
import ThreeDRotation from "@material-ui/icons/ThreeDRotation";
import CCC from "@material-ui/icons/RemoveFromQueue";
import TrackChanges from "@material-ui/icons/TrackChanges";
import TrendingUp from "@material-ui/icons/TrendingUp";
import CAD from "@material-ui/icons/AddToQueue";
// import Code from "@material-ui/icons/Code";
import DeveloperMode from "@material-ui/icons/DeveloperMode";
import Settings from "@material-ui/icons/Settings";
import Gesture from "@material-ui/icons/Gesture";
import PersonPin from "@material-ui/icons/PersonPin";
import Sms from "@material-ui/icons/Sms";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Timeline from "@material-ui/icons/Timeline";
import Adb from "@material-ui/icons/Adb";
import Notes from "@material-ui/icons/Notes";
import Collapse from "@material-ui/core/Collapse";
import DevicesOther from "@material-ui/icons/DevicesOther";
import Home from "./Home";
import Profile from "./Profile";
import Project from "./Project";
import Exercise from "./Exercises";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

// import hljs from "highlight.js";
// import "highlight.js/styles/github.css";

// const Empty = () => {
//   return (
//     <div>
//       <Typography align="center" variant="h4">
//         Page not found.
//       </Typography>
//     </div>
//   );
// };

const drawerWidth = 240;

let title = "Home"; //global variables for routing
let page = "";

const styles = theme => ({
  root: {
    display: "flex"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`
    }
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class ResponsiveDrawer extends React.Component {
  state = {
    mobileOpen: false,
    projectOpen: false,
    exeOpen: false,
    page: "", //change to ""
    title: "Home",
    showComment: false
  };

  componentDidMount() {
    // console.log(this.state.title);
    // console.log(this.state.page);
    this.setState({ page: page, title: title, showComment: true });
    console.log("App Ready...");
    console.log("Makers gonna Make.");
    console.log(this.state.title);
    console.log(this.state.page);
    // hljs.initHighlightingOnLoad();
  }

  componentDidUpdate() {
    window.document.dispatchEvent(
      new Event("DOMContentLoaded", {
        bubbles: true,
        cancelable: true
      })
    );
    // hljs.initHighlightingOnLoad();
  }

  handlePage = (number, newtitle) => {
    this.setState({ page: number, title: newtitle });
    page = number;
    title = newtitle;
    this.setState({ mobileOpen: false });
  };

  handleClick = () => {
    this.setState(state => ({ projectOpen: !state.projectOpen }));
  };

  handleClick2 = () => {
    this.setState(state => ({ exeOpen: !state.exeOpen }));
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  render() {
    const { classes } = this.props;

    const drawer = (
      <div>
        <div />
        <Toolbar>
          <Typography variant="title" color="inherit">
            Fab Academy 2020
          </Typography>
        </Toolbar>
        <Divider />
        {/* <Router> */}
        <List>
          <ListItem
            selected={this.state.page === ""}
            component={RouterLink}
            to="/"
            onClick={() => this.handlePage("", "Home")}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>

          <ListItem button onClick={this.handleClick}>
            <ListItemIcon>
              <DevicesOther />
            </ListItemIcon>
            <ListItemText primary="Project" />
            {this.state.projectOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.projectOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                selected={this.state.page === "p1"}
                component={RouterLink}
                to="/p1"
                onClick={() => this.handlePage("p1", "Concept")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Dashboard />
                </ListItemIcon>
                <ListItemText secondary="Concept" />
              </ListItem>
              <ListItem
                selected={this.state.page === "p2"}
                component={RouterLink}
                to="/p2"
                onClick={() => this.handlePage("p2", "Notes")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Notes />
                </ListItemIcon>
                <ListItemText secondary="Notes" />
              </ListItem>
              <ListItem
                selected={this.state.page === "p3"}
                component={RouterLink}
                to="/p3"
                onClick={() => this.handlePage("p3", "Timeline")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Timeline />
                </ListItemIcon>
                <ListItemText secondary="Timeline" />
              </ListItem>
              <ListItem
                selected={this.state.page === "p4"}
                component={RouterLink}
                to="/p4"
                onClick={() => this.handlePage("p4", "Result")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Adb />
                </ListItemIcon>
                <ListItemText secondary="Result" />
              </ListItem>
            </List>
          </Collapse>
          <ListItem button onClick={this.handleClick2}>
            <ListItemIcon>
              <Gesture />
            </ListItemIcon>
            <ListItemText primary="Exercise" />
            {this.state.exeOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.exeOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                component={RouterLink}
                to="/e1"
                selected={this.state.page === "e1"}
                onClick={() =>
                  this.handlePage("e1", "Principles and Practices")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <TrendingUp />
                </ListItemIcon>
                <ListItemText secondary="Principles and Practices" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e2"}
                component={RouterLink}
                to="/e2"
                onClick={() => this.handlePage("e2", "Project Management")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <TrackChanges />
                </ListItemIcon>
                <ListItemText secondary="Project Management" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e3"}
                component={RouterLink}
                to="/e3"
                onClick={() => this.handlePage("e3", "Computer-Aided Design")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <CAD />
                </ListItemIcon>
                <ListItemText secondary="Computer-Aided Design" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e4"}
                component={RouterLink}
                to="/e4"
                onClick={() =>
                  this.handlePage("e4", "Computer-Controlled Cutting")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <CCC />
                </ListItemIcon>
                <ListItemText secondary="Computer-Controlled Cutting" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e5"}
                component={RouterLink}
                to="/e5"
                onClick={() => this.handlePage("e5", "Electronics Production")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Memory />
                </ListItemIcon>
                <ListItemText secondary="Electronics Production" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e6"}
                component={RouterLink}
                to="/e6"
                onClick={() =>
                  this.handlePage("e6", "3D scanning and Printing")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <ThreeDRotation />
                </ListItemIcon>
                <ListItemText secondary="3D scanning and Printing" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e7"}
                component={RouterLink}
                to="/e7"
                onClick={() => this.handlePage("e7", "Electronics Design")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Usb />
                </ListItemIcon>
                <ListItemText secondary="Electronics Design" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e8"}
                component={RouterLink}
                to="/e8"
                onClick={() =>
                  this.handlePage("e8", "Computer-Controlled Machining")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <Motorcycle />
                </ListItemIcon>
                <ListItemText secondary="Computer-Controlled Machining" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e9"}
                component={RouterLink}
                to="/e9"
                onClick={() => this.handlePage("e9", "Embedded Programming")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <DeveloperBoard />
                </ListItemIcon>
                <ListItemText secondary="Embedded Programming" />
              </ListItem>

              <ListItem
                selected={this.state.page === "e10"}
                component={RouterLink}
                to="/e10"
                onClick={() => this.handlePage("e10", "Molding and Casting")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Toys />
                </ListItemIcon>
                <ListItemText secondary="Molding and Casting" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e11"}
                component={RouterLink}
                to="/e11"
                onClick={() => this.handlePage("e11", "Input Devices")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Mouse />
                </ListItemIcon>
                <ListItemText secondary="Input Devices" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e12"}
                component={RouterLink}
                to="/e12"
                onClick={() => this.handlePage("e12", "Output Devices")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Headset />
                </ListItemIcon>
                <ListItemText secondary="Output Devices" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e13"}
                component={RouterLink}
                to="/e13"
                onClick={() =>
                  this.handlePage("e13", "Applications and Implications")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <VideogameAsset />
                </ListItemIcon>
                <ListItemText secondary="Applications and Implications" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e14"}
                component={RouterLink}
                to="/e14"
                onClick={() =>
                  this.handlePage("e14", "Networking and Communications")
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <CellWifi />
                </ListItemIcon>
                <ListItemText secondary="Networking and Communications" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e15"}
                component={RouterLink}
                to="/e15"
                onClick={() => this.handlePage("e15", "Mechanical Design")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Build />
                </ListItemIcon>
                <ListItemText secondary="Mechanical Design" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e16"}
                component={RouterLink}
                to="/e16"
                onClick={() =>
                  this.handlePage(
                    "e16",
                    "Interface and Application Programming"
                  )
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <DeveloperMode />
                </ListItemIcon>
                <ListItemText secondary="Interface and Application Programming" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e17"}
                component={RouterLink}
                to="/e17"
                onClick={() => this.handlePage("e17", "Machine Design")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Settings />
                </ListItemIcon>
                <ListItemText secondary="Machine Design" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e18"}
                component={RouterLink}
                to="/e18"
                onClick={() =>
                  this.handlePage(
                    "e18",
                    "Invention, Intellectual Property, and Income"
                  )
                }
                className={classes.nested}
              >
                <ListItemIcon>
                  <AttachMoney />
                </ListItemIcon>
                <ListItemText secondary="Invention, Intellectual Property, and Income" />
              </ListItem>
              <ListItem
                selected={this.state.page === "e19"}
                component={RouterLink}
                to="/e19"
                onClick={() => this.handlePage("e19", "Project Development")}
                className={classes.nested}
              >
                <ListItemIcon>
                  <Adb />
                </ListItemIcon>
                <ListItemText secondary="Project Development" />
              </ListItem>
            </List>
          </Collapse>
        </List>
        {/* </Router> */}
        <Divider />
        <List>
          <ListItem
            selected={this.state.page === "m1"}
            component={RouterLink}
            to="/m1"
            onClick={() => this.handlePage("m1", "About")}
          >
            <ListItemIcon>
              <PersonPin />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItem>
          <ListItem
            selected={this.state.page === "m2"}
            component={RouterLink}
            to="/m2"
            onClick={() => this.handlePage("m2", "Contact")}
          >
            <ListItemIcon>
              <Sms />
            </ListItemIcon>
            <ListItemText primary="Contact" />
          </ListItem>
        </List>
      </div>
    );

    return (
      <Router basename="/2020/labs/vigyanashram/students/manojsahukar/#!">
        <div className={classes.root}>
          <CssBaseline />
          <Helmet>
            <title>{this.state.title + " | Manoj Sahukar"}</title>
          </Helmet>

          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              <Switch>
                <Route
                  render={() => {
                    // this.handlePage("error", "Not found");
                    return (
                      <Typography variant="h6" color="inherit" noWrap>
                        {this.state.title}
                        {/* not */}
                      </Typography>
                    );
                  }}
                />
              </Switch>
            </Toolbar>
          </AppBar>
          <nav className={classes.drawer}>
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden smUp implementation="css">
              <SwipeableDrawer
                container={this.props.container}
                variant="temporary"
                // anchor={theme.direction === "rtl" ? "right" : "left"}
                open={this.state.mobileOpen}
                onOpen={this.handleDrawerToggle}
                onClose={this.handleDrawerToggle}
                classes={{ paper: classes.drawerPaper }}
              >
                {drawer}
              </SwipeableDrawer>
            </Hidden>
            <Hidden xsDown implementation="css">
              <Drawer
                classes={{ paper: classes.drawerPaper }}
                variant="permanent"
                open
              >
                {drawer}
              </Drawer>
            </Hidden>
          </nav>
          <main className={classes.content}>
            <div className={classes.toolbar} />

            <Switch>
              <Route
                exact
                path="/"
                render={() => {
                  title = "Home";
                  page = "";
                  return <Home />;
                }}
              />
              {/* <Route exact path="/" component={Home} /> */}

              <Route
                path="/p1"
                render={() => {
                  title = "Concept";
                  page = "p1";
                  return <Project.Concept />;
                }}
              />
              {/* <Route path="/p1" component={Project.Concept} /> */}

              <Route
                path="/p2"
                render={() => {
                  title = "Notes";
                  page = "p2";
                  return <Project.Notes />;
                }}
              />
              {/* <Route path="/p2" component={Project.Notes} /> */}

              <Route
                path="/p3"
                render={() => {
                  title = "Timeline";
                  page = "p3";
                  return <Project.Timeline />;
                }}
              />
              {/* <Route path="/p3" component={Project.Timeline} /> */}

              <Route
                path="/p4"
                render={() => {
                  title = "Result";
                  page = "p4";
                  return <Project.Result />;
                }}
              />
              {/* <Route path="/p4" component={Project.Result} /> */}
              <Route
                path="/e1"
                render={() => {
                  title = "Principles and Practices";
                  page = "e1";
                  return <Exercise.Exercise01 />;
                }}
              />
              {/* <Route path="/e1" component={Exercise.Exercise01} /> */}
              <Route
                path="/e2"
                render={() => {
                  title = "Project Management";
                  page = "e2";
                  return <Exercise.Exercise02 />;
                }}
              />
              {/* <Route path="/e2" component={Exercise.Exercise02} /> */}
              <Route
                path="/e3"
                render={() => {
                  title = "Computer-Aided Design";
                  page = "e3";
                  return <Exercise.Exercise03 />;
                }}
              />
              {/* <Route path="/e3" component={Exercise.Exercise03} /> */}
              <Route
                path="/e4"
                render={() => {
                  title = "Computer-Controlled Cutting";
                  page = "e4";
                  return <Exercise.Exercise04 />;
                }}
              />
              {/* <Route path="/e4" component={Exercise.Exercise04} /> */}
              <Route
                path="/e5"
                render={() => {
                  title = "Electronics Production";
                  page = "e5";
                  return <Exercise.Exercise05 />;
                }}
              />
              {/* <Route path="/e5" component={Exercise.Exercise05} /> */}
              <Route
                path="/e6"
                render={() => {
                  title = "3D scanning and Printing";
                  page = "e6";
                  return <Exercise.Exercise06 />;
                }}
              />
              {/* <Route path="/e6" component={Exercise.Exercise06} /> */}
              <Route
                path="/e7"
                render={() => {
                  title = "Electronics Design";
                  page = "e7";
                  return <Exercise.Exercise07 />;
                }}
              />
              {/* <Route path="/e7" component={Exercise.Exercise07} /> */}
              <Route
                path="/e8"
                render={() => {
                  title = "Computer-Controlled Machining";
                  page = "e8";
                  return <Exercise.Exercise08 />;
                }}
              />
              {/* <Route path="/e8" component={Exercise.Exercise08} /> */}
              <Route
                path="/e9"
                render={() => {
                  title = "Embedded Programming";
                  page = "e9";
                  return <Exercise.Exercise09 />;
                }}
              />
              {/* <Route path="/e9" component={Exercise.Exercise09} /> */}
              <Route
                path="/e10"
                render={() => {
                  title = "Molding and Casting";
                  page = "e10";
                  return <Exercise.Exercise10 />;
                }}
              />
              {/* <Route path="/e10" component={Exercise.Exercise10} /> */}
              <Route
                path="/e11"
                render={() => {
                  title = "Input Devices";
                  page = "e11";
                  return <Exercise.Exercise11 />;
                }}
              />
              {/* <Route path="/e11" component={Exercise.Exercise11} /> */}
              <Route
                path="/e12"
                render={() => {
                  title = "Output Devices";
                  page = "e12";
                  return <Exercise.Exercise12 />;
                }}
              />
              {/* <Route path="/e12" component={Exercise.Exercise12} /> */}
              <Route
                path="/e13"
                render={() => {
                  title = "Applications and Implications";
                  page = "e13";
                  return <Exercise.Exercise13 />;
                }}
              />
              {/* <Route path="/e13" component={Exercise.Exercise13} /> */}
              <Route
                path="/e14"
                render={() => {
                  title = "Networking and Communications";
                  page = "e14";
                  return <Exercise.Exercise14 />;
                }}
              />
              {/* <Route path="/e14" component={Exercise.Exercise14} /> */}
              <Route
                path="/e15"
                render={() => {
                  title = "Mechanical Design";
                  page = "e15";
                  return <Exercise.Exercise15 />;
                }}
              />
              {/* <Route path="/e15" component={Exercise.Exercise15} /> */}
              <Route
                path="/e16"
                render={() => {
                  title = "Interface and Application Programming";
                  page = "e16";
                  return <Exercise.Exercise16 />;
                }}
              />
              {/* <Route path="/e16" component={Exercise.Exercise16} /> */}
              <Route
                path="/e17"
                render={() => {
                  title = "Machine Design";
                  page = "e17";
                  return <Exercise.Exercise17 />;
                }}
              />
              {/* <Route path="/e17" component={Exercise.Exercise17} /> */}
              <Route
                path="/e18"
                render={() => {
                  title = "Invention, Intellectual Property, and Income";
                  page = "e18";
                  return <Exercise.Exercise18 />;
                }}
              />
              {/* <Route path="/e18" component={Exercise.Exercise18} /> */}
              <Route
                path="/e19"
                render={() => {
                  title = "Project Development";
                  page = "e19";
                  return <Exercise.Exercise19 />;
                }}
              />
              {/* <Route path="/e19" component={Exercise.Exercise19} /> */}
              <Route
                path="/e20"
                render={() => {
                  title = "Project Development";
                  page = "e20";
                  return <Exercise.Exercise20 />;
                }}
              />
              {/* <Route path="/e20" component={Exercise.Exercise20} /> */}

              <Route
                path="/m1"
                render={() => {
                  title = "About";
                  page = "m1";
                  return <Profile.About />;
                }}
              />
              {/* <Route path="/m1" component={Profile.About} /> */}

              <Route
                path="/m2"
                render={() => {
                  title = "Contact";
                  page = "m2";
                  return <Profile.Contact />;
                }}
              />
              {/* <Route path="/m2" component={Profile.Contact} /> */}

              <Route
                render={() => {
                  title = "Home";
                  page = "";
                  // console.log(this.state.title);
                  // console.log(this.state.page);
                  // this.setState();
                  return <Home />;
                }}
              />
              {/* <Route component={Empty} /> */}
            </Switch>

            {/* {this.state.page === "" && <Home />}
          {this.state.page === "p1" && <Project.Concept />}
          {this.state.page === "p2" && <Project.Notes />}
          {this.state.page === "p3" && <Project.Timeline />}
          {this.state.page === "p4" && <Project.Result />}
          {this.state.page === "e1" && <Exercise.Exercise01 />}
          {this.state.page === "e2" && <Exercise.Exercise02 />}
          {this.state.page === "e3" && <Exercise.Exercise03 />}
          {this.state.page === "e4" && <Exercise.Exercise04 />}
          {this.state.page === "e5" && <Exercise.Exercise05 />}
          {this.state.page === "e6" && <Exercise.Exercise06 />}
          {this.state.page === "e7" && <Exercise.Exercise07 />}
          {this.state.page === "e8" && <Exercise.Exercise08 />}
          {this.state.page === "e9" && <Exercise.Exercise09 />}
          {this.state.page === "e10" && <Exercise.Exercise10 />}
          {this.state.page === "e11" && <Exercise.Exercise11 />}
          {this.state.page === "e12" && <Exercise.Exercise12 />}
          {this.state.page === "e13" && <Exercise.Exercise13 />}
          {this.state.page === "e14" && <Exercise.Exercise14 />}
          {this.state.page === "e15" && <Exercise.Exercise15 />}
          {this.state.page === "e16" && <Exercise.Exercise16 />}
          {this.state.page === "e17" && <Exercise.Exercise17 />}
          {this.state.page === "e18" && <Exercise.Exercise18 />}
          {this.state.page === "e19" && <Exercise.Exercise19 />}
          {this.state.page === "e20" && <Exercise.Exercise20 />}
          {this.state.page === "m1" && <Profile.About />}
          {this.state.page === "m2" && <Profile.Contact />} */}
            <br />
            {/* {this.state.page !== "empty" && this.state.showComment===false && (
              <Comments id={this.state.page} title={this.state.title} />
            )} */}
            {this.state.showComment === true && (
              <Comments id={this.state.page} title={this.state.title} />
            )}
            <br />
            <Divider />
            <Toolbar>
              <Typography variant="subtitle1" color="inherit">
                &copy; 2020 Manoj Sahukar
              </Typography>
            </Toolbar>
          </main>
        </div>
      </Router>
    );
  }
}

ResponsiveDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  // Injected by the documentation to work in an iframe.
  // You won't need it on your project.
  container: PropTypes.object,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(ResponsiveDrawer);
